module.exports = __webpack_public_path__ + "images/noReviewImage.4b54fb44.svg";